import React from "react";

import { Box, Heading, Layer, Text } from "grommet"
import Spinner from './Spinner'

import { ReactComponent as PinkTTLogo } from '../../assets/logo-tt-full.svg';

export const SpinnerOverlay = ({ textDisplay = "Data Initializing...", logo = false }) => (

    <Layer position="center" modal={false} >
        <Box pad="medium" gap="small" width="250px" height="250px" align="center" alignContent="center" alignSelf="center" background="light-1">
            {logo &&
                <PinkTTLogo />
            }
            <Heading level={4} margin={{ top: "30px", bottom: "15px" }} align="center" color="dark-3" textAlign="center">
                {textDisplay}
            </Heading>
            <Spinner />
        </Box>
    </Layer>
)

export const SpinnerOverlayAthena = ({ logo = false }) => (

    <Layer position="center" modal={false} >
        <Box pad="medium" gap="small" width="350px" height="250px" align="center" alignContent="center" alignSelf="center" background="light-1">
            {logo &&
                <PinkTTLogo />
            }
            <Heading level={4} margin={{ top: "30px", bottom: "15px" }} align="center" color="dark-3" textAlign="center">
                Querying Athena Database...
            </Heading>
            <Text size="small">This may take up to a minute please wait</Text>
            <Spinner />
        </Box>
    </Layer>
)


export default SpinnerOverlay;
